process.env

export const mappingLevel = {
    A1: { en: 'A1 - Beginner', ja: 'A1 - 初級' },
    A2: { en: 'A2 - Lower Intermediate', ja: 'A2 - 初中級' },
    B1: { en: 'B1 - Intermediate', ja: 'B1 - 中級' },
    B2: { en: 'B2 - Upper Intermediate', ja: 'B2 - 上中級' },
    easy: { en: 'Easy' },
    medium: { en: 'Medium' },
    hard: { en: 'Hard' },
  }

// convert to array int type
export const orgsAvailableELSAAI = process.env.VUE_APP_ELSA_AI_ORG_IDS.split(',').map(Number)

export const orgsAvailableAssessment = process.env.VUE_APP_ASSESSMENT_ORG_IDS.split(',').map(Number)

export const colorLevelAI = {
  advanced: '#28CCE0',
  intermediate: '#47A1F5',
  elementary: '#3272F0'
}
